import { IACHDisbursementFormData } from 'types/order/escrow/achDisbursements/IACHDisbursementFormData';
import { ICheckDisbursementFormData } from 'types/order/escrow/checks/ICheckDisbursementFormData';
import { IWireDisbursementFormData } from 'types/order/escrow/wires/IWireDisbursementFormData';
import { IOrderDetailsData } from 'ui-toolkit/orders/interfaces/IOrderDetailsData';
import { v4 } from 'uuid';
import { defaultMemo } from '../defaultMemo';
import { IInternalTransferDisbursementFormData } from 'types/order/escrow/internalTransferDisbursements/IInternalTransferDisbursementFormData';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { ICreateSettlementFeeForm } from 'types/order/fees/ICreateSettlementItemForm';
import { defaultCreate } from '../defaultCreate';

export const WireConversions = {
  ACH: (
    achData: IACHDisbursementFormData,
    order: IOrderDetailsData,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): IWireDisbursementFormData => {
    const { amountCents, statementFeeId, holdback, holdbackProperties, account } = achData;
    const memo = defaultMemo(order, isSpruceWithZillowEnabled, isZillowClosing);
    return {
      type: eDisbursementType.Wire,
      id: v4(),
      amountCents,
      memo,
      isNew: true,
      statementFeeId,
      holdback,
      holdbackProperties,
      beneficiary: account?.name ?? '',
    };
  },
  Check: (
    checkData: ICheckDisbursementFormData,
    order: IOrderDetailsData,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): IWireDisbursementFormData => {
    const { name, amountCents, statementFeeId, holdback, holdbackProperties } = checkData;
    const memo = defaultMemo(order, isSpruceWithZillowEnabled, isZillowClosing);
    return {
      type: eDisbursementType.Wire,
      id: v4(),
      isNew: true,
      beneficiary: name ?? '',
      category: undefined,
      statementFeeId,
      amountCents,
      memo,
      holdback,
      holdbackProperties,
    };
  },
  'Internal Transfer': (
    internalTransfer: IInternalTransferDisbursementFormData,
    order: IOrderDetailsData,
    fee: ICreateSettlementFeeForm,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): IWireDisbursementFormData => {
    const { amountCents, statementFeeId, holdback, holdbackProperties } = internalTransfer;
    const { beneficiary, memo } = defaultCreate(fee, order, isSpruceWithZillowEnabled, isZillowClosing);
    return {
      type: eDisbursementType.Wire,
      id: v4(),
      amountCents,
      memo,
      isNew: true,
      statementFeeId,
      holdback,
      holdbackProperties,
      beneficiary,
    };
  },
};
